import {
  ENGAGEMENT_ID_OUTPUT_KEY,
  ToolEngagementActionTypeEnum,
} from '@reach/shared-types/tool-engagement';

export const ENGAGEMENT_OUTCOME_OPTIONS = [
  {
    value: '',
    title: 'No engagement action',
    description:
      'This tool may support another outcome or supply data, but it doesn’t create an engagement.',
  },
  {
    value: ToolEngagementActionTypeEnum.ENGAGEMENT_CREATED,
    title: 'An engagement was created',
    description: 'A booking, appointment, visit, or job now exists.',
  },
  {
    value: ToolEngagementActionTypeEnum.ENGAGEMENT_LINK_CREATED,
    title: 'An engagement link was sent',
    description: 'The customer received a link to create the engagement later.',
  },
] as const;

export const ENGAGEMENT_ACTION_COPY = {
  sectionTitle: 'Track this tool’s outcome',
  sectionSubtitle: 'Choose what Reach should record after this tool runs successfully.',
  outcomeLegend: 'What should a successful run record?',
  actionExplanations: {
    [ToolEngagementActionTypeEnum.ENGAGEMENT_CREATED]: `Reach ties the successful run to the synced engagement through the required "${ENGAGEMENT_ID_OUTPUT_KEY}" response field.`,
    [ToolEngagementActionTypeEnum.ENGAGEMENT_LINK_CREATED]:
      'The link is tracked separately and does not mean a booking exists. Reach can match it to an engagement only after your system syncs one.',
  },
  schemaPrompts: {
    [ToolEngagementActionTypeEnum.ENGAGEMENT_CREATED]: {
      label: 'What kind of engagement was created?',
      hint: 'Choose the synced schema that holds this booking, appointment, visit, or job.',
    },
    [ToolEngagementActionTypeEnum.ENGAGEMENT_LINK_CREATED]: {
      label: 'What kind of engagement can this link create?',
      hint: 'The link is tracked separately until it can be matched to an engagement synced through Data Integration.',
    },
  },
  missingAction:
    'This tool has a saved engagement schema but no action. Choose what a successful run should record, or select no engagement action.',
  missingSchema: 'Choose the engagement schema for this outcome.',
  chooseSchema: 'Choose a schema…',
  savedSchema: 'Saved schema',
  savedSchemaUnavailable: 'Saved schema is no longer available',
  unavailableSchema: 'Choose an active schema; the saved schema is no longer available.',
  loadingSchemas: 'Loading synced schemas…',
  schemaLoadFailure: 'Synced schemas could not be loaded.',
  retrySchemaLoad: 'Try again',
  noActiveSchemas:
    "You don't have a synced schema for bookings yet. Set one up in Data Integration first, then come back.",
  requiredMappingTitle: 'Connect the created engagement',
  requiredMappingDescriptionLead: 'Map the engagement’s ID from the upstream response to a field named',
  requiredMappingSuggestionLead: 'Use',
  requiredMappingSuggestionConnector: 'as',
  requiredMappingSamplePrompt: 'Run a test or paste a sample response, then choose the engagement ID.',
} as const;

export const unreadableEngagementActionMessage = (action: string): string =>
  `This tool is set to "${action}", which this dashboard doesn't recognize. Choose one of the options above to replace it.`;

export const requiredEngagementMappingSuggestion = (suggestedPath: string, outputName: string): string =>
  `Use ${suggestedPath} as ${outputName}`;
